// ** Navigation sections imports
import dashboard from "./dashboard"
import management from "./management"
import category from "./category"
import system from "./system"
import report from "./report"
import configuration from "./configuration"
import application from "./application"
import history from "./history"

// ** Merge & Export
export default [...dashboard, ...management, ...category, ...system, ...report, ...configuration, ...application, ...history]
